// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"u--z","button":"v--z","disabled":"w--z","creditCard":"x--z","wrapper":"y--z"};